import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface AllergieStudentModel {
  id: number;
  nomFr: string;
  nomAr: string;
  selected: string; // '0' or '1'
}

@Injectable({
  providedIn: 'root',
})
export class InfoenfantService {
  private apiBaseUrl = environment.apiUrl.replace(/\/$/, '');
  private baseUrl = 'https://mon-compte.educanet.pro';

  constructor(private http: HttpClient) {}

  /** Retourne l'URL de base de l'API */
  getApiUrl(): string {
    return this.baseUrl;
  }

  /** Récupérer le profil d'un élève */
getStudentProfile(
  idStudent: string,
  idOrganization: string,
  idBatch: string
): Observable<any> {
  const url = `${this.baseUrl}/api/student/getProfilStudent/${idStudent}/${idOrganization}/${idBatch}`;
  return this.http.get(url).pipe(
    catchError(error => {
      console.error('getStudentProfile Error:', error);
      return throwError(() => new Error(error));
    })
  );
}

getEcoleByStudentId(studentId: number): Observable<any> {
  const url = `${this.apiBaseUrl}/comportement/getEcoleByStudentId/${studentId}`;
  return this.http.get<any>(url).pipe(
    catchError(error => {
      console.error('Erreur lors de l’appel à getEcoleByStudentId:', error);
      return throwError(() => error);
    })
  );
}


  /** Récupérer les informations de la famille par ID étudiant */
getFamilleByStudentId(studentId: string): Observable<any> {
  const url = `${this.apiBaseUrl}/comportement/getFamilleByStudentId/${studentId}`;
  return this.http.get<any>(url).pipe(
    catchError(error => {
      console.error('Erreur dans getFamilleByStudentId:', error);
      return throwError(() => error);
    })
  );
}

getFamille2ByStudentId(studentId: string): Observable<any> {
  const url = `${this.apiBaseUrl}/comportement/getFamille2ByStudentId/${studentId}`;
  return this.http.get<any>(url).pipe(
    catchError(error => {
      console.error('Erreur dans getFamille2ByStudentId:', error);
      return throwError(() => error);
    })
  );
}


  /** Récupérer le profil sans cache (anti cache via querystring) */
  getStudentProfileNoCache(
    idStudent: string,
    userId: string,
    dOrg: string,
    batchId: string
  ): Observable<any> {
    const url = `${
      this.baseUrl
    }/mobile/studentProfile/getByStudentId/${idStudent}/${userId}/${dOrg}/${batchId}?nocache=${new Date().getTime()}`;
    return this.http.get(url);
  }

  /** Mettre à jour le profil d'un élève */
updateStudentProfile(
  idStudent: number,
  nom: string,
  prenom: string,
  dateNaissance: string,
  lieuNaissance: string,
  arabName: string,
  admissionNumber: string,
  numPere: string,
  deuxNumPere: string,
  lstAllergie: string[] = [] // facultatif
): Observable<any> {
  // ✅ URL exacte selon la documentation
  const url = `${this.apiBaseUrl}/student/updateStudent/${idStudent}`;

  // ✅ Corps de la requête conforme à la spécification
  const body = {
    nom,
    prenom,
    datenais: dateNaissance,
    lieunais: lieuNaissance,
    arabename: arabName,
    lstallergie: lstAllergie,
    admissionNumber,
    numpere: numPere,
    deuxiemnumpere: deuxNumPere,
  };

  // ✅ Appel POST propre avec gestion d’erreur
  return this.http.post(url, body).pipe(
    catchError((error) => {
      console.error('updateStudentProfile Error:', error);
      return throwError(() => error);
    })
  );
}


  /** Mettre à jour les informations de l'école d'un élève */
updateEcole(idStudent: number, id: number, ecoleData: any): Observable<any> {
  const url = `${this.apiBaseUrl}/comportement/updateEcole/${idStudent}/${id}`;

  return this.http.post(url, ecoleData).pipe(
    catchError(error => {
      console.error('updateEcole Error:', error);
      return throwError(() => error);
    })
  );
}


  /** Mettre à jour les informations de la famille d'un élève */
updateFamille(idStudent: number, familyData: any): Observable<any> {
  const url = `${this.apiBaseUrl}/comportement/updateFamille/${idStudent}`;

  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  });

  return this.http.post(url, familyData, { headers }).pipe(
    catchError(error => {
      console.error('Erreur updateFamille:', error);
      return throwError(() => error);
    })
  );
}


 /** Mettre à jour les informations de santé/comportement d'un élève */
updateSante(idStudent: string, santeData: any): Observable<any> {
  const url = `${this.apiBaseUrl}/comportement/updateSante/${idStudent}`;
  return this.http.post(url, santeData).pipe(
    catchError(error => {
      console.error('updateSante Error:', error); // Log error
      return throwError(() => error);
    })
  );
}

  /** Récupérer les informations de santé par ID étudiant */
getSanteByStudentId(studentId: string): Observable<any> {
  const url = `${this.apiBaseUrl}/comportement/getSanteByStudent/${studentId}`;
  return this.http.get(url).pipe(
    catchError(error => {
      console.error('getSanteByStudentId Error:', error); // Log error
      return throwError(() => new Error(error));
    })
  );
}


  /** Récupérer les informations de comportement par ID étudiant */
getComportementByStudentId(idStudent: number): Observable<any> {
  const url = `${this.apiBaseUrl}/comportement/getByStudent/${idStudent}`;
  return this.http.get(url).pipe(
    catchError(error => {
      console.error('getComportementByStudentId Error:', error); // Log error
      return throwError(() => error);
    })
  );
}


  /** Update student photo */
// service : InfoenfantService
updateUserPhoto(file: File, idUser: number): Observable<any> {
  const url = `${this.apiBaseUrl}/user/updatePhotoProfile?idUser=${idUser}`;
  const formData = new FormData();
  formData.append('file', file);

  return this.http.post(url, formData).pipe(
    catchError(error => {
      console.error('Erreur upload photo:', error);
      return throwError(() => error);
    })
  );
}




  /** Récupérer les allergies par ID étudiant */
getAllergieByStudentId(
  studentId: number,
  orgId: number,
  batchId: number
): Observable<any> {
  const url = `${this.apiBaseUrl}/allergieCantine/listAllergieByStudent/${studentId}/${orgId}/${batchId}`;
  return this.http.get(url).pipe(
    catchError(error => {
      console.error('getAllergieByStudentId Error:', error);
      return throwError(() => error);
    })
  );
}


  /** Mettre à jour les allergies d'un élève */
setAllergie(
  idBatch: number,
  idStudent: number,
  idOrganization: number,
  allergieIds: number[]
): Observable<any> {
  // ✅ Ordre correct selon la documentation API
  const url = `${this.apiBaseUrl}/allergieCantine/update/${idBatch}/${idStudent}/${idOrganization}`;

  const body = {
    playMode: null,
    behaviour: null,
    cryAttitude: null,
    shyAttitude: null,
    games: null,
    meneur: null,
    introverti: null,
    irritManifest: null,
    notesDeComportement: null,
    dresseAllown: null,
    enjoyMeal: null,
    eatEvreything: null,
    aliments: null,
    detestedMeal: null,
    health: null,
    hospitalized: null,
    hospitalReason: null,
    hospitalAge: null,
    walkingAge: null,
    disease: null,
    dentalRecord: null,
    allergie: null,
    fever: null,
    nervous: null,
    convulsion: null,
    extraProblem: null,
    vaccinScolaire: null,
    bloodType: null,
    nameOfDoctor: null,
    adressDoctor: null,
    allerg1: allergieIds.length > 0 ? allergieIds.join(',') : null,
    allerg2: null,
    allerg3: null,
    allerg4: null
  };

  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  });

  return this.http.post(url, body, { headers }).pipe(
    catchError(error => {
      console.error('Erreur dans setAllergie:', error);
      return throwError(() => error);
    })
  );
}



}